/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { env } from '../env'
import { getUTMParams } from '../helpers/getUTMParams'
import { runWhenActivated } from '../helpers/runWhenActivated'
import { getCurrentPublicPageBotSignal } from '../helpers/publicPageBotGuard'
import { createNoopAnalytics } from './noopAnalytics'
import {
  isAnalyticsConsented,
  whenAnalyticsConsented,
} from '../helpers/publicCookieConsent'
import { isPublicPublishPath } from '../helpers/publicPublishPaths'

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

window.PRODUCT_TRACKING_KEY = 'publish'
window.CLIENT_NAME = 'publishWeb'
;(function () {
  // Recognizable bots on the public /p pages get a no-op analytics stub
  // instead of Segment: they don't keep cookies, so every crawl would mint a
  // fresh anonymousId and bill a full MTU. Returning here also skips the
  // breadcrumbs proxy fallback below, which would otherwise load Segment for
  // the same page view. Best-effort cost control, not access control — see
  // ./README.md and ../helpers/publicPageBotGuard.ts.
  const botSignal = getCurrentPublicPageBotSignal()
  if (botSignal) {
    window.__analyticsSkippedReason = botSignal
    window.analytics = createNoopAnalytics()
    return
  }

  const writeKey = isPublicPublishPath(window.location.pathname)
    ? env.VITE_PUBLIC_SEGMENT_KEY
    : env.VITE_SEGMENT_KEY

  // AppShell installs its own loader when this queue is absent.
  const analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize && !analytics.invoked) {
    analytics.invoked = !0
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware',
    ]
    analytics.factory = function (e) {
      return function () {
        if (!writeKey || !isAnalyticsConsented()) return analytics
        // eslint-disable-next-line prefer-rest-params
        const t = Array.prototype.slice.call(arguments)
        t.unshift(e)
        analytics.push(t)
        return analytics
      }
    }
    for (let e = 0; e < analytics.methods.length; e++) {
      const key = analytics.methods[e]
      analytics[key] = analytics.factory(key)
    }
    analytics.load = function (src, options, onError) {
      if (!writeKey || !isAnalyticsConsented()) return
      const t = document.createElement('script')
      t.type = 'text/javascript'
      t.async = !0
      t.addEventListener('error', onError)
      t.src = src
      const n = document.getElementsByTagName('script')[0]
      n.parentNode.insertBefore(t, n)
      analytics._loadOptions = options
    }
    if (!writeKey) return

    analytics._writeKey = writeKey
    analytics._cdn = 'https://segment-analytics.buffer.com'
    analytics.SNIPPET_VERSION = '4.15.2'
    whenAnalyticsConsented(() => {
      runWhenActivated(document, () => {
        analytics.load(
          `https://segment-analytics.buffer.com/analytics.js/v1/${writeKey}/analytics.min.js`,
          {
            obfuscate: true,
            integrations: {
              'Segment.io': { apiHost: 'segment-api.buffer.com/v1' },
            },
          },
          function onError() {
            throw new Error('SegmentLibrary::NotLoaded')
          },
        )
        const urlParams = new URLSearchParams(window.location.search)
        analytics.page({
          cta: urlParams.get('cta'),
          ...getUTMParams(urlParams),
          screenWidth: screen.width,
          screenHeight: screen.height,
          viewportWidth: window.innerWidth,
          viewportHeight: window.innerHeight,
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc'),
        })
      })
    })

    // If something breaks loading Segment let's try with the proxy
    window.addEventListener('error', ({ message }) => {
      if (
        isAnalyticsConsented() &&
        message === 'Uncaught Error: SegmentLibrary::NotLoaded'
      ) {
        analytics._cdn = 'https://breadcrumbs.buffer.com'
        analytics.load(
          `https://breadcrumbs.buffer.com/?key=${writeKey}`,
          {
            obfuscate: true,
            integrations: {
              'Segment.io': { apiHost: 'breadcrumbs.buffer.com/v1' },
            },
          },
          (onError = () => {
            data = { userAgent: navigator.userAgent }
            fetch('https://buffer-segment-monitor.bufferapp.workers.dev/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data),
            })
            throw new Error('SegmentProxy::NotLoaded')
          }),
        )
      }
    })
  }
})()
